import React, { ReactNode } from 'react';

import { Box, Group, Text } from '@mantine/core';
import { Icon, IconProps } from '@tabler/icons-react';

interface SingleInfoDetailProps {
  label: string;
  value: ReactNode | string;
  icon?: React.ForwardRefExoticComponent<IconProps & React.RefAttributes<Icon>>;
}

export default function SingleInfoDetail({
  label,
  value,
  icon,
}: SingleInfoDetailProps) {
  // ==========================================================================
  // General
  // ==========================================================================

  // ==========================================================================
  // State
  // ==========================================================================

  // ==========================================================================
  // Api
  // ==========================================================================

  // ==========================================================================
  // Form
  // ==========================================================================

  // ==========================================================================
  // Handlers
  // ==========================================================================

  // ==========================================================================
  // Render
  // ==========================================================================
  return (
    <Box p="xs" key={label}>
      <Group>
        {icon && React.createElement(icon, { size: 24 })}

        <div>
          <Text size="sm" fw={600}>
            {label}
          </Text>
          <Text>{value || 'N.d.'}</Text>
        </div>
      </Group>
    </Box>
  );
}
